import { appQueryClient } from '@libs/data-access/queries'

import type { FetchLineManagersOptions } from '../lineManagers.api'
import { fetchLineManagers } from '../lineManagers.api'
import { lineManagerQueryKeys } from '../lineManagers.cacheKeys'

export const getLineManagers = (request: FetchLineManagersOptions) => {
  return appQueryClient.fetchQuery({
    queryKey: lineManagerQueryKeys.get_line_manager(request?.queryParams),
    queryFn: () => fetchLineManagers(request)
  })
}
